import BybVrCard from "@Components/common/byb-ds/cards/byb-vr-card";
import useI18n from "@i18n";
import { Box, Fade, Slide, keyframes, useTheme } from "@mui/material";
import { TrainingFocus } from "@Shared/schemas/progression/progressionSchemas";
import { useState } from "react";

import renderMetricContent from "@Components/game/progress/training-focus/training-focus-card-content";
import {
  CONTENT_TRANSITION_DURATION,
  triggerTrainingFocusCompletionHaptics,
} from "@Components/game/progress/training-focus/training-focus-feedback.utils";

const borderPulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(255, 211, 61, 0.75);
  }
  100% {
    box-shadow: 0 0 0 10px rgba(255, 211, 61, 0);
  }
`;

interface ITrainingFocusCard {
  displayedMetric: TrainingFocus["metric"] | null;
  previousMetric: TrainingFocus["metric"] | null;
  isLoading: boolean;
  isTransitionActive: boolean;
  isTransitionEntered: boolean;
  onClick: () => void;
  onTransitionComplete: () => void;
}

export const TrainingFocusCard = ({
  displayedMetric,
  previousMetric,
  isLoading,
  isTransitionActive,
  isTransitionEntered,
  onClick,
  onTransitionComplete,
}: ITrainingFocusCard) => {
  const { i18n, i18nWithComponents } = useI18n();
  const theme = useTheme();
  const [isBorderPulsing, setIsBorderPulsing] = useState(false);

  const handleTransitionEntered = () => {
    onTransitionComplete();
    setIsBorderPulsing(true);
    triggerTrainingFocusCompletionHaptics();
  };

  return (
    <Box
      onAnimationEnd={() => setIsBorderPulsing(false)}
      sx={{
        borderRadius: theme.spacing(4),
        animation: isBorderPulsing ? `${borderPulse} 600ms ease-out` : "none",
      }}
    >
      <BybVrCard>
        <Box display="grid" width="100%">
          {isTransitionActive && (
            <Fade in={!isTransitionEntered} timeout={CONTENT_TRANSITION_DURATION} appear={false}>
              {renderMetricContent(previousMetric, isLoading, onClick, i18n, i18nWithComponents)}
            </Fade>
          )}
          {isTransitionActive ? (
            <Slide in={isTransitionEntered} direction="right" timeout={CONTENT_TRANSITION_DURATION} onEntered={handleTransitionEntered}>
              {renderMetricContent(displayedMetric, isLoading, onClick, i18n, i18nWithComponents)}
            </Slide>
          ) : (
            renderMetricContent(displayedMetric, isLoading, onClick, i18n, i18nWithComponents)
          )}
        </Box>
      </BybVrCard>
    </Box>
  );
};
